import { ErrorBoundary } from '@sentry/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedRadarTemplateAtom, setRadarTemplateEditAtom } from '@/atoms/radar';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { hasEditPermissions } from '@/utils/userConfigs';

const RadarTemplateEditMenuOptionBase = ({ onClick, isDisabled }: { onClick?: () => void; isDisabled?: boolean }) => {
  const { t } = useTranslation('general');

  return <MenuItemWithIcon icon="Edit" disabled={isDisabled} onClick={onClick} text={t('edit')} />;
};

const RadarTemplateEditMenuOptionWithData = () => {
  const selectedTemplate = useAtomValue(selectedRadarTemplateAtom);
  const setRadarTemplateEdit = useSetAtom(setRadarTemplateEditAtom);

  if (!selectedTemplate) {
    throw new Error('Unable to find selected radar template');
  }

  return (
    <RadarTemplateEditMenuOptionBase
      isDisabled={!hasEditPermissions(selectedTemplate.permission)}
      onClick={() => setRadarTemplateEdit({ template: selectedTemplate })}
    />
  );
};

export const RadarTemplateEditMenuOption = () => (
  <ErrorBoundary fallback={<RadarTemplateEditMenuOptionBase isDisabled />}>
    <Suspense fallback={<RadarTemplateEditMenuOptionBase isDisabled />}>
      <RadarTemplateEditMenuOptionWithData />
    </Suspense>
  </ErrorBoundary>
);
